import UserCheckinsPage from './UserCheckins.container';

export default UserCheckinsPage;
